import qs from "qs";
const prefix = "__config__";
export class Configuration {
    constructor(config, env, storage, search = "") {
        this.config = config;
        this.storage = storage;
        this.search = search;
        let value = this.getParam(this.getKey("env"));
        if (value === undefined) {
            value = storage.getItem(this.getKey("env")) || undefined;
            if (value === undefined) {
                value = env;
            }
        }
        this.env = value || "";
        console.log("env", this.env);
    }
    extract(key) {
        let value = this.getParam(this.getKey(key));
        if (value === undefined) {
            value = this.storage.getItem(this.getKey(key)) || undefined;
            if (value === undefined) {
                value = this.config[key];
                if (typeof value === "object") {
                    value = value[this.env];
                }
            }
        }
        return value ?? "";
    }
    getKey(key) {
        return prefix + key;
    }
    getParam(key) {
        let search = this.search;
        if (search.startsWith("?"))
            search = search.substring(1);
        const params = qs.parse(this.search);
        return params[key]?.toString();
    }
}
